import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import AuthenticationPage from "./features/authentication/AuthenticationPage";
import { upload as uploadCountries } from "./features/citySelect/selectCitySlice";
import Path from "./features/path/Path";
import RegistrationPage from "./features/registration/RegistrationPage";
import CreateShipmentItemPopup from "./features/shipment/CreateShipmentItem/CreateShipmentItemPopup";
import EditShipmentItemPopup from "./features/shipment/EditShipmentItem/EditShipmentItemPopup";
import ShipmentPage from "./features/shipment/ShipmentPage";
import ShipmentPopup from "./features/shipments/shipmentPopup/ShipmentPopup";
import ShipmentsList from "./features/shipments/shipmentsList/ShipmentsList";
import Header from "./components/header/Header";
import ShipmentEventsPopup from "./features/shipments/shipmentEvents/ShipmentEventsPopup";
import CalcPage from "./features/calc/CalcPage";
import ProfilePage from "./features/user/ProfilePage";
import AlertsComponent from "./features/alerts/AlertsComponent";
import { getUser } from "./features/user/userSlice";
import { uploadProductTypes } from "./features/productTypeSelect/productTypeSelectSlice";
import { selectAuthenticated } from "./features/authentication/authSlice";
import { selectRegistrated } from "./features/registration/registrationSlice";
import SendToAkadPopup from "./features/shipments/shipmentsList/SendToAkadPopup/SendToAkadPopup";
import DeleteShipmentPopup from "./features/shipment/DeleteShipmentPopup/DeleteShipmentPopup";
import ShipmentBills from "./features/shipmentBills/ShipmentBills";
import SavedReceiversPage from "./features/savedReceivers/SavedReceiversPage";
import EditSavedReceiverPopup from "./features/savedReceivers/EditSavedReceiverPopup";
import DeleteSavedReceiverPopup from "./features/savedReceivers/DeleteSavedReceiverPopup";
import SuccessPaymentPage from "./components/paymentPages/SuccessPaymentPage";
import FailedPaymentPage from "./components/paymentPages/FailedPaymentPage";
import AuthenticationChecker from "./features/authentication/AuthenticationChecker";
import { uploadShipmentBills } from "./features/shipmentBills/shipmentBillsSlice";
import DeleteBoxPopup from "./features/shipment/DeleteBoxPopup/DeleteBoxPopup";
import TitleChanger from "./components/TitleChanger";
import ShipmentSendToAkadPopup from "./features/shipment/sendToAkad/SendToAkadPopup";
import ResetPassword from "./features/authentication/ResetPassword";
import ConfirmResetPassword from "./features/authentication/ConfirmResetPassword";
import Footer from "./components/footer/Footer";
import Admin from "./features/admin/Admin";
import { checkIsAdmin, selectIsAdmin } from "./features/admin/adminSlice";
import AdminHeader from "./components/header/AdminHeader";
import TestNestPay from "./TestNestPay";

function App() {
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const authenticated = useSelector(selectAuthenticated);
    const registrated = useSelector(selectRegistrated);

    const isAdmin = useSelector(selectIsAdmin);

    useEffect(() => {
        dispatch(uploadCountries());
        dispatch(getUser());
        dispatch(uploadProductTypes());
        dispatch(uploadShipmentBills());
    }, [dispatch]);

    useEffect(() => {
        if (authenticated || registrated) {
            dispatch(uploadCountries());
            dispatch(getUser());
            dispatch(uploadProductTypes());
            dispatch(uploadShipmentBills());
        }
    }, [dispatch, authenticated, registrated]);

    useEffect(() => {
        dispatch(checkIsAdmin());
    }, [dispatch]);

    return (
        <>
            <div
                className="App mx-auto relative overflow-hidden"
                style={{
                    minHeight: "100vh",
                    maxWidth: "1366px",
                    zIndex: 90,
                }}
            >
                <ShipmentPopup />
                <SendToAkadPopup />
                <ShipmentSendToAkadPopup />
                <EditShipmentItemPopup />
                <CreateShipmentItemPopup />
                <DeleteBoxPopup />
                <ShipmentEventsPopup />
                <DeleteShipmentPopup />
                <EditSavedReceiverPopup />
                <DeleteSavedReceiverPopup />
                {/* Header */}
                {!isAdmin ? <Header /> : <AdminHeader />}
                {/* Main */}
                <div
                    className="pt-20"
                    style={{
                        maxWidth: "1280px",
                        borderRadius: "10px",
                        margin: "0 auto",
                    }}
                >
                    <Routes path="/">
                        <Route path="/admin/*" element={<Admin />} />
                        <Route
                            path="/"
                            element={
                                isAdmin !== "loading" && isAdmin ? (
                                    <Admin />
                                ) : (
                                    <ShipmentsList />
                                )
                            }
                        />

                        <Route path="/shipments" element={<ShipmentsList />} />
                        <Route
                            path="/shipments/:shipmentID"
                            element={<ShipmentPage />}
                        />

                        <Route path="/calc" element={<CalcPage />} />

                        <Route path="/profile" element={<ProfilePage />} />

                        <Route
                            path="/authentication"
                            element={<AuthenticationPage />}
                        />
                        <Route
                            path="/registration"
                            element={<RegistrationPage />}
                        />
                        <Route
                            path="/reset-password"
                            element={<ResetPassword />}
                        />
                        <Route
                            path="/reset-password/confirm"
                            element={<ConfirmResetPassword />}
                        />

                        <Route
                            path="/shipment-bills"
                            element={<ShipmentBills />}
                        />
                        <Route
                            path="/saved-receivers"
                            element={<SavedReceiversPage />}
                        />

                        <Route
                            path="/success-payment"
                            element={<SuccessPaymentPage />}
                        />
                        <Route
                            path="/failed-payment"
                            element={<FailedPaymentPage />}
                        />
                        <Route
                            path="/test/nestpay"
                            element={<TestNestPay />}
                        />
                    </Routes>
                    {/* Alerts */}
                    <AlertsComponent />
                </div>
                {/* Footer */}
                <Footer />
            </div>
            <Path />
            <AuthenticationChecker />
            <TitleChanger />
        </>
    );
}

export default App;
